module.exports = __webpack_public_path__ + "resources/img/img_dataquery.d4ffa0bb77afa48f70690fc46deaafa3.png";